import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiUrls } from './ApiUrls';
import { RegistrationModerationModel } from '../model/RegistrationModerationModel';
import { PushtoMLResponseModel } from '../model/PushtoMLResponseModel';
import { Page } from '../model/Page';
import { RegistrationModerationDetailModel } from '../model/RegistrationModerationDetailModel';
import { RegistrationModerationVerificationModel } from '../model/RegistrationModerationVerificationModel';
import { RegistrationModerationAuditTrailModel } from '../model/RegistrationModerationAuditTrailModel';
import { RegistrationModerationDocumentAuditTrailModel } from '../model/RegistrationModerationDocumentAuditTrailModel';

@Injectable({
  providedIn: 'root'
})
export class ModerationService {

  constructor(private httpClient: HttpClient) { }

  fetchModerationList(page: number, size: number, filterText: string) {
    return this.httpClient.get<Page<RegistrationModerationModel>>(ApiUrls.moderationList + 
      `?page=${page}&size=${size}&filterText=${filterText}`);
  }

  fetchModerationDetail(registrationModerationKey: number) {
    return this.httpClient.get<RegistrationModerationDetailModel>(ApiUrls.moderationDetail.replace('{registrationModerationKey}', registrationModerationKey.toString()));
  }

  fetchMlPendingDocuments(pan: string) {
    return this.httpClient.get<PushtoMLResponseModel>(
      ApiUrls.findMLPendingDocuments.replace('{pan}', pan));
  }

  submitVerificationDetail(registrationModerationDetailModel: RegistrationModerationDetailModel) {
    let docArr: RegistrationModerationVerificationModel[] = [];

    // public originalDesignation: string,
    //     public curOrganizationName: string,
    //     public designation: string,

    registrationModerationDetailModel.moderationDocuments.forEach(rmd => {
      docArr.push(new RegistrationModerationVerificationModel(rmd.registrationModerationDocumentKey, 
        rmd.status, rmd.rejectRemarks, rmd.annualIncome, 
        rmd.isDocReadable, rmd.hasBarcode, rmd.afterPeriod, rmd.barcode, 
        rmd?.rejectReasonSystem?.key, rmd?.originalDesignation , rmd?.curOrganizationName, rmd?.designation
        ));
    });

    return this.httpClient.post<{status: string, errorMessage: string}>(ApiUrls.moderationDetail.replace('{registrationModerationKey}', 
      registrationModerationDetailModel.registrationModerationKey.toString()), {
        moderationDocuments: docArr
    });
  }

  fetchModerationAuditTrail(page: number, size: number, filterText: string) {
    return this.httpClient.get<Page<RegistrationModerationAuditTrailModel>>(ApiUrls.moderationAuditTrail + 
      `?page=${page}&size=${size}&filterText=${filterText}`);
  }

  fetchModerationDocumentAuditTrail(registrationId: number) {
    return this.httpClient.get<RegistrationModerationDocumentAuditTrailModel>(ApiUrls.moderationDocumentAuditTrail.replace('{registrationId}', registrationId.toString()));
  }
}
